// Brevo (Sendinblue) Email Configuration
export const BREVO_CONFIG = {
  API_KEY: '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',
  API_URL: 'https://api.brevo.com/v3/smtp/email',
  FROM_EMAIL: 'haithemmihoubi1234@gmail.com',
  FROM_NAME: 'TaxiVD',
  RECIPIENT_EMAIL: 'info@taxivd.ch'
};

